
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { handleError, initClient } from '../../../api';
import { ActionDefinition, ActionsApiUiClient } from '../../backend/backendapi';
import ActionDefinitionStore from '../../../stores/ActionDefinitionStore';
import DefinitionEditor from './DefinitionEditor';
import { emptyUUID, WindowType } from '../../../util';
import Spinner from '../../util/Spinner';
import { availableTypes } from './DefinitionEditor';

declare var window: WindowType;

@Component({
  components: {
    DefinitionEditor,
    Spinner,
  },
})
export default class DefinitionEditModal extends Vue {
  private readonly api = initClient(ActionsApiUiClient);
  private readonly store = new ActionDefinitionStore();

  definition: ActionDefinition | null = null;
  isNew: boolean = true;
  saving = false;
  canSave = false;
  
  onCanSaveChanged(canSave: boolean) {
    this.canSave = canSave;
  }

  public open(definition: ActionDefinition, isNew: boolean): void {
    if (isNew) { // fill missing props otherwise reactivity not working
      definition.id ??= emptyUUID();
      definition.accountId ??= window.application.user.fkAccountId ?? -1;
      definition.name ??= '';
      definition.description ??= '';
      definition.type ??= availableTypes.length ? availableTypes[0] : '';
      definition.configurationJson = '{}';
    }
    this.definition = ActionDefinition.fromJS(definition); // make copy for editing, otherwise we modify the cached version used elsewhere
    this.isNew = isNew;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private async save(): Promise<void> {
    if (!this.definition) {
      return;
    }

    this.saving = true;
    try {
      let res: ActionDefinition;
      if (this.isNew) {
        res = await this.api.insert(this.definition);
      } else {
        res = await this.api.update(this.definition);
      }

      this.$toasted.info(this.$t('txtSaved').toString());
      this.$emit('saved');
      this.store.updateDefinition(res);
      this.isNew = false;
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
